<div *ngIf="megaMenuColumns$ | async as columns">
    <div class="menu-container">
        <p-mega-menu-column *ngFor="let column of columns" [column]="column" (close)="close.emit($event)"> </p-mega-menu-column>
    </div>
</div>
